/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ClientSurveyVersionModel } from '../../models/client-survey-version-model';
import { UpdateSurveyVersionRequest } from '../../models/update-survey-version-request';

export interface UpdateSurveyVersionAsync$Plain$Params {

/**
 * surveyversion id
 */
  surveyVersionId: number;
  
    /**
     * surveyversion request variables
     */
    body?: UpdateSurveyVersionRequest
}

export function updateSurveyVersionAsync$Plain(http: HttpClient, rootUrl: string, params: UpdateSurveyVersionAsync$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientSurveyVersionModel>> {
  const rb = new RequestBuilder(rootUrl, updateSurveyVersionAsync$Plain.PATH, 'put');
  if (params) {
    rb.path('surveyVersionId', params.surveyVersionId, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ClientSurveyVersionModel>;
    })
  );
}

updateSurveyVersionAsync$Plain.PATH = '/api/SurveyVersion/{surveyVersionId}';
